import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import csvPanZoom from "svg-pan-zoom";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {isDesktop} from "react-device-detect";

const ComfortWiringManual = props => {
  const {getApiPrimaryParams, setPrintData, unsetPrintData} = useTecRmi()
  const [manualHtml, setManualHtml] = useState(null)

  useEffect(() => () => unsetPrintData(), [])

  useDidMountEffect(() => {
    const params = {
      ...getApiPrimaryParams(),
      printView: false,
      manualId: props.manualId,
    }

    setPrintData(apiUser.tecRmi.comfortWiring.manualHtmlPrint, {
      ...params,
      printView: true,
    })

    apiUser.tecRmi.comfortWiring.manualHtml(params)
      .then(res => setManualHtml(res.data))
  })

  return (
    <div>
      {!manualHtml && <LoadingSpinner />}
      {manualHtml && <TecRmiSvgHtml
        html={manualHtml[0]}
        className="svg-styled"
        onDidMount={() => {
          if(isDesktop && document.querySelector('#svg0')){
            const resetNav = document.querySelector('img[src="https://rmi-cdn.tecalliance.net/services/RESET.png"]')
            if(resetNav){
              const _table = resetNav.closest('table')
              if(_table){
                const td = _table.closest('td')
                if(td){
                  td.remove()
                }
              }
            }

            csvPanZoom('#svg0', {
              zoomScaleSensitivity: 0.25,
              maxZoom: 20,
              minZoom: 0.8,
            })
          }
        }}
      />}
    </div>
  );
};

ComfortWiringManual.propTypes = {
  manualId: PropTypes.number.isRequired,
};

export default ComfortWiringManual;